var _style, _g, _g2, _g3, _g4, _g5, _g6;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgTitleLatKiberkvests = function SvgTitleLatKiberkvests(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 1440 766",
    style: {
      enableBackground: "new 0 0 1440 766"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{display:inline;}\r\n\t.st2{fill:#060606;}\r\n\t.st3{display:inline;fill:#060606;}\r\n\t.st4{display:inline;fill:none;}\r\n\t.st5{display:inline;fill:#FFFFFF;}\r\n\t.st6{font-family:'SEBSansSerif-Bold';}\r\n\t.st7{font-size:370px;}\r\n\t.st8{letter-spacing:-18;}\r\n\t.st9{font-size:60px;}\r\n\t.st10{letter-spacing:-3;}\r\n\t.st11{font-size:90px;}\r\n\t.st12{letter-spacing:-4;}\r\n\t.st13{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1020.8,357.5c-22,0-41.7,15.3-44.3,45h89.3C1062.8,372.8,1042.8,357.5,1020.8,357.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M0,0v766h1440V0H0z M1046.8,245.1v52h-52v-52C994.8,245.1,1046.8,245.1,1046.8,245.1z M368.8,327.5 c0,54-38.7,83-90,83h-50.3v112.7h-55v-280h105.3c51.3-0.1,90,28.6,90,82.3V327.5z M434.4,523.1h-51.3v-200h51.3V523.1z  M434.8,297.1h-52v-52h52V297.1z M635.2,523.1h-51.3v-118c0-27-12.3-42-33.3-42c-22.7,0-36.7,18.7-36.7,45.3v114.7h-51.3v-200 h47.6v22c13.3-19,34.3-26,54.3-26c43.3,0,70.7,29.3,70.7,73.7L635.2,523.1L635.2,523.1z M779.8,523.1l-52-83.3l-17.7,19.3v64 h-49.7v-280h0.1h51.3v154.3l65-74.3h62.3l-75.3,82.7l76.3,117.3H779.8L779.8,523.1z M921.8,523.1h-24.3c-32,0-52-18-52-52.3 V243.1h51.3v218.7c0,12,5,17.3,14,17.3h11V523.1z M1117.1,435.9H974.4c1.3,30.3,22.7,49.3,50,49.3c16,0,32.3-6.7,40.3-22.7 l48.3,8.7c-14.6,37.6-51.2,57.9-90.2,57.9c-53.3,0-98.3-38-98.3-104.3v-3.3c0-66.3,43.3-104.3,96.3-104.3 c53,0,96.3,38,96.3,105.7L1117.1,435.9L1117.1,435.9z M1209.1,527.3c-35.7-0.2-71-13.5-91.7-53.2l44-17.3c9.3,19.7,23,30,45.3,30 c20.7,0,32-9,32-22.3s-11-18.3-25.3-21l-30-5.3c-44.3-8.3-62-28.3-62-55c0-33,25.7-64,79.3-64c35,0,66,13.3,85.7,46l-43.7,17.7 c-9-16.3-22.7-23.3-39.7-23.3c-19.7,0-30.3,9-30.3,21c0,10.3,8.7,16,24,19l29.7,5.3c44.3,8.7,63.7,27.3,63.7,56.7 C1290.1,496.6,1263.1,527.3,1209.1,527.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M275.8,290.8h-47.3v72h47.3c22.7,0,37-13,37-36.3C312.8,303.5,298.5,290.8,275.8,290.8z"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "LV",
    className: "st0"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st3",
    width: 1440,
    height: 766
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.7,
    y: 99,
    className: "st4",
    width: 1194.7,
    height: 568
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 262.2617 357.9933)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "st5 st6 st7 st8"
  }, "Kib"), /*#__PURE__*/React.createElement("tspan", {
    x: 484.7,
    y: 0,
    className: "st5 st6 st9 st10"
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 493.7,
    y: 0,
    className: "st5 st6 st7 st8"
  }, "er-"), /*#__PURE__*/React.createElement("tspan", {
    x: -60.9,
    y: 250,
    className: "st5 st6 st11 st12"
  }), /*#__PURE__*/React.createElement("tspan", {
    x: -47.4,
    y: 250,
    className: "st5 st6 st7 st8"
  }, "k"), /*#__PURE__*/React.createElement("tspan", {
    x: 126.4,
    y: 250,
    className: "st5 st6 st9 st10"
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 135.4,
    y: 250,
    className: "st5 st6 st7 st8"
  }, "ve"), /*#__PURE__*/React.createElement("tspan", {
    x: 501.7,
    y: 250,
    className: "st5 st6 st9 st10"
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 510.7,
    y: 250,
    className: "st5 st6 st7 st8"
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    x: 666.1,
    y: 250,
    className: "st5 st6 st9 st10"
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 675.1,
    y: 250,
    className: "st5 st6 st7 st8"
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 793.5,
    y: 250,
    className: "st5 st6 st9 st10"
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 802.5,
    y: 250,
    className: "st5 st6 st7 st8"
  }, "s")), /*#__PURE__*/React.createElement("rect", {
    x: 101.3,
    y: 112.3,
    className: "st4",
    width: 1194.7,
    height: 568
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 287.1759 371.3267)",
    className: "st1"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "st13 st6 st7 st8"
  }, "Kib"), /*#__PURE__*/React.createElement("tspan", {
    x: 484.7,
    y: 0,
    className: "st13 st6 st9 st10"
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 493.7,
    y: 0,
    className: "st13 st6 st7 st8"
  }, "er"), /*#__PURE__*/React.createElement("tspan", {
    x: -147.7,
    y: 250,
    className: "st13 st6 st11 st12"
  }), /*#__PURE__*/React.createElement("tspan", {
    x: -53.2,
    y: 250,
    className: "st13 st6 st7 st8"
  }, "k"), /*#__PURE__*/React.createElement("tspan", {
    x: 120.7,
    y: 250,
    className: "st13 st6 st9 st10"
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 129.7,
    y: 250,
    className: "st13 st6 st7 st8"
  }, "ve"), /*#__PURE__*/React.createElement("tspan", {
    x: 496,
    y: 250,
    className: "st13 st6 st9 st10"
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 505,
    y: 250,
    className: "st13 st6 st7 st8"
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    x: 660.4,
    y: 250,
    className: "st13 st6 st9 st10"
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 669.4,
    y: 250,
    className: "st13 st6 st7 st8"
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 787.8,
    y: 250,
    className: "st13 st6 st9 st10"
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 796.8,
    y: 250,
    className: "st13 st6 st7 st8"
  }, "s")))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "EE",
    className: "st0"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st3",
    width: 1440,
    height: 766
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.7,
    y: 99,
    className: "st4",
    width: 1194.7,
    height: 568
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 211.2637 357.9933)",
    className: "st1"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "st13 st6 st7 st8"
  }, "K\xFCber-"), /*#__PURE__*/React.createElement("tspan", {
    x: 92.5,
    y: 270,
    className: "st13 st6 st7 st8"
  }, "katse")))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "RU",
    className: "st0"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st3",
    width: 1440,
    height: 766
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.7,
    y: 99,
    className: "st4",
    width: 1194.7,
    height: 568
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 211.2637 357.9933)",
    className: "st1"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "st13 st6 st7 st8"
  }, "K\xFCber-"), /*#__PURE__*/React.createElement("tspan", {
    x: 92.5,
    y: 250,
    className: "st13 st6 st7 st8"
  }, "katse")))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "LV_name_SVG"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M673,210c-23.4,0-41.3,18.5-41.3,54.6v1.8c0,35.5,17.9,54.6,41.3,54.6c23.7,0,41.6-19.1,41.6-54.6v-1.8 C714.6,228.5,696.7,210,673,210z M865.1,204.8c-20.4,0-38.6,14.2-41,41.6h82.6C904,218.9,885.5,204.8,865.1,204.8z M865.1,204.8 c-20.4,0-38.6,14.2-41,41.6h82.6C904,218.9,885.5,204.8,865.1,204.8z M673,210c-23.4,0-41.3,18.5-41.3,54.6v1.8 c0,35.5,17.9,54.6,41.3,54.6c23.7,0,41.6-19.1,41.6-54.6v-1.8C714.6,228.5,696.7,210,673,210z M673,210 c-23.4,0-41.3,18.5-41.3,54.6v1.8c0,35.5,17.9,54.6,41.3,54.6c23.7,0,41.6-19.1,41.6-54.6v-1.8C714.6,228.5,696.7,210,673,210z  M865.1,204.8c-20.4,0-38.6,14.2-41,41.6h82.6C904,218.9,885.5,204.8,865.1,204.8z M865.1,204.8c-20.4,0-38.6,14.2-41,41.6h82.6 C904,218.9,885.5,204.8,865.1,204.8z M673,210c-23.4,0-41.3,18.5-41.3,54.6v1.8c0,35.5,17.9,54.6,41.3,54.6 c23.7,0,41.6-19.1,41.6-54.6v-1.8C714.6,228.5,696.7,210,673,210z M673,210c-23.4,0-41.3,18.5-41.3,54.6v1.8 c0,35.5,17.9,54.6,41.3,54.6c23.7,0,41.6-19.1,41.6-54.6v-1.8C714.6,228.5,696.7,210,673,210z M865.1,204.8 c-20.4,0-38.6,14.2-41,41.6h82.6C904,218.9,885.5,204.8,865.1,204.8z M865.1,204.8c-20.4,0-38.6,14.2-41,41.6h82.6 C904,218.9,885.5,204.8,865.1,204.8z M673,210c-23.4,0-41.3,18.5-41.3,54.6v1.8c0,35.5,17.9,54.6,41.3,54.6 c23.7,0,41.6-19.1,41.6-54.6v-1.8C714.6,228.5,696.7,210,673,210z M673,210c-23.4,0-41.3,18.5-41.3,54.6v1.8 c0,35.5,17.9,54.6,41.3,54.6c23.7,0,41.6-19.1,41.6-54.6v-1.8C714.6,228.5,696.7,210,673,210z M681.2,454.8 c-20.4,0-38.5,14.2-41,41.6h82.6C720,468.9,701.5,454.8,681.2,454.8z M865.1,204.8c-20.4,0-38.6,14.2-41,41.6h82.6 C904,218.9,885.5,204.8,865.1,204.8z M865.1,204.8c-20.4,0-38.6,14.2-41,41.6h82.6C904,218.9,885.5,204.8,865.1,204.8z  M681.2,454.8c-20.4,0-38.5,14.2-41,41.6h82.6C720,468.9,701.5,454.8,681.2,454.8z M673,210c-23.4,0-41.3,18.5-41.3,54.6v1.8 c0,35.5,17.9,54.6,41.3,54.6c23.7,0,41.6-19.1,41.6-54.6v-1.8C714.6,228.5,696.7,210,673,210z M0,0v766h1440V0.2L0,0z M973.9,173 h44.1v30.2c13-21,37-32.1,65.7-32.1v47.5c-39.5,0-62.3,24-62.3,63.5V358h-47.5V173z M585.7,99h47.5v92.2 c10.2-11.7,26.8-21.9,50.3-21.9c40.1,0,78.6,29.6,78.6,89.4v13.6c0,59.8-38.2,89.4-79.9,89.4c-25,0-42.5-10.2-52.4-22.2V358h-44.1 V99z M512,100.8h48.1v48.1H512V100.8z M559.8,173v185h-47.5V173H559.8z M299.9,99h50.9v107.9c5.5-10.8,12.3-21.3,18.5-30.2l53-77.7 h57.7L405,206l99,152h-61l-73.4-114.4l-18.8,25V358h-50.9V99z M353.7,608l-48.1-77.1l-16.3,17.9V608h-45.9V349h47.5v142.8 l60.1-68.8h57.7l-69.7,76.5L409.5,608H353.7z M480.4,608l-68.8-185h52.7l31.8,97.1c3.1,9.9,6.2,20.7,9.9,37 c3.4-16.3,6.5-27.4,9.6-37l32.1-97.1h49l-68.8,185H480.4z M770.3,527.2h-132c1.2,28.1,21,45.6,46.3,45.6c14.8,0,29.9-6.2,37.3-21 l44.7,8c-13.6,34.8-47.5,53.6-83.6,53.6c-49.3,0-91-35.1-91-96.5V514c0-61.4,40.1-96.5,89.1-96.5c49,0,89.1,35.1,89.1,97.7V527.2z  M776,264c0-61.4,40.1-96.5,89.1-96.5c49,0,89.1,35.1,89.1,97.7v12h-132c1.2,28.1,21,45.6,46.3,45.6c14.8,0,29.9-6.2,37.3-21 l44.7,8c-13.6,34.8-47.5,53.6-83.6,53.6c-49.3,0-91-35.1-91-96.5V264z M864.4,611.7c-33,0-65.7-12.3-84.8-49l40.7-16 c8.6,18.2,21.3,27.8,41.9,27.8c19.1,0,29.6-8.3,29.6-20.7c0-12.3-10.2-17-23.4-19.4l-27.8-4.9c-41-7.7-57.3-26.2-57.3-50.9 c0-30.5,23.7-59.2,73.4-59.2c32.4,0,61,12.3,79.2,42.5l-40.4,16.3c-8.3-15.1-21-21.6-36.7-21.6c-18.2,0-28.1,8.3-28.1,19.4 c0,9.6,8,14.8,22.2,17.6l27.4,4.9c41,8,58.9,25.3,58.9,52.4C939.3,583.3,914.3,611.7,864.4,611.7z M1064.5,463.7h-45.6v80.5 c0,16.3,8.3,23.1,21.9,23.1h23.7V608h-36.4c-34.8,0-56.7-18.5-56.7-55.2v-89.1h-25.3V423H973v-55.5h44.1V423h47.5V463.7z  M1156.2,611.7c-33,0-65.7-12.3-84.8-49l40.7-16c8.6,18.2,21.3,27.8,41.9,27.8c19.1,0,29.6-8.3,29.6-20.7c0-12.3-10.2-17-23.4-19.4 l-27.8-4.9c-41-7.7-57.3-26.2-57.3-50.9c0-30.5,23.7-59.2,73.4-59.2c32.4,0,61,12.3,79.2,42.5l-40.4,16.3 c-8.3-15.1-21-21.6-36.7-21.6c-18.2,0-28.1,8.3-28.1,19.4c0,9.6,8,14.8,22.2,17.6l27.4,4.9c41,8,58.9,25.3,58.9,52.4 C1231.1,583.3,1206.1,611.7,1156.2,611.7z M865.1,204.8c-20.4,0-38.6,14.2-41,41.6h82.6C904,218.9,885.5,204.8,865.1,204.8z  M681.2,454.8c-20.4,0-38.5,14.2-41,41.6h82.6C720,468.9,701.5,454.8,681.2,454.8z M673,321c23.7,0,41.6-19.1,41.6-54.6v-1.8 c0-36.1-17.9-54.6-41.6-54.6c-23.4,0-41.3,18.5-41.3,54.6v1.8C631.6,301.9,649.5,321,673,321z M673,210 c-23.4,0-41.3,18.5-41.3,54.6v1.8c0,35.5,17.9,54.6,41.3,54.6c23.7,0,41.6-19.1,41.6-54.6v-1.8C714.6,228.5,696.7,210,673,210z  M681.2,454.8c-20.4,0-38.5,14.2-41,41.6h82.6C720,468.9,701.5,454.8,681.2,454.8z M865.1,204.8c-20.4,0-38.6,14.2-41,41.6h82.6 C904,218.9,885.5,204.8,865.1,204.8z M865.1,204.8c-20.4,0-38.6,14.2-41,41.6h82.6C904,218.9,885.5,204.8,865.1,204.8z  M681.2,454.8c-20.4,0-38.5,14.2-41,41.6h82.6C720,468.9,701.5,454.8,681.2,454.8z M673,210c-23.4,0-41.3,18.5-41.3,54.6v1.8 c0,35.5,17.9,54.6,41.3,54.6c23.7,0,41.6-19.1,41.6-54.6v-1.8C714.6,228.5,696.7,210,673,210z M673,210 c-23.4,0-41.3,18.5-41.3,54.6v1.8c0,35.5,17.9,54.6,41.3,54.6c23.7,0,41.6-19.1,41.6-54.6v-1.8C714.6,228.5,696.7,210,673,210z  M865.1,204.8c-20.4,0-38.6,14.2-41,41.6h82.6C904,218.9,885.5,204.8,865.1,204.8z M865.1,204.8c-20.4,0-38.6,14.2-41,41.6h82.6 C904,218.9,885.5,204.8,865.1,204.8z M673,210c-23.4,0-41.3,18.5-41.3,54.6v1.8c0,35.5,17.9,54.6,41.3,54.6 c23.7,0,41.6-19.1,41.6-54.6v-1.8C714.6,228.5,696.7,210,673,210z M673,210c-23.4,0-41.3,18.5-41.3,54.6v1.8 c0,35.5,17.9,54.6,41.3,54.6c23.7,0,41.6-19.1,41.6-54.6v-1.8C714.6,228.5,696.7,210,673,210z M865.1,204.8 c-20.4,0-38.6,14.2-41,41.6h82.6C904,218.9,885.5,204.8,865.1,204.8z M865.1,204.8c-20.4,0-38.6,14.2-41,41.6h82.6 C904,218.9,885.5,204.8,865.1,204.8z M673,210c-23.4,0-41.3,18.5-41.3,54.6v1.8c0,35.5,17.9,54.6,41.3,54.6 c23.7,0,41.6-19.1,41.6-54.6v-1.8C714.6,228.5,696.7,210,673,210z M673,210c-23.4,0-41.3,18.5-41.3,54.6v1.8 c0,35.5,17.9,54.6,41.3,54.6c23.7,0,41.6-19.1,41.6-54.6v-1.8C714.6,228.5,696.7,210,673,210z M673,210 c-23.4,0-41.3,18.5-41.3,54.6v1.8c0,35.5,17.9,54.6,41.3,54.6c23.7,0,41.6-19.1,41.6-54.6v-1.8C714.6,228.5,696.7,210,673,210z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "EE_name_SVG",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M537.5,570.3c0,14.5,10.8,24,28.1,24c23.7,0,41.9-15.7,41.9-42.2v-5.2h-40.1 C546.7,546.9,537.5,556.5,537.5,570.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M724.6,321c23.7,0,41.6-19.1,41.6-54.6v-1.9c0-36.1-17.9-54.6-41.6-54.6c-23.4,0-41.3,18.5-41.3,54.6v1.9 C683.3,301.9,701.2,321,724.6,321z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M907.8,204.8c-20.3,0-38.5,14.2-41,41.6h82.6C946.6,218.9,928.1,204.8,907.8,204.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M0,0v766h1440V0H0z M1016.6,173h44.1v30.2c13-21,37-32.1,65.7-32.1v47.5c-39.5,0-62.3,24.1-62.3,63.5V358 h-47.5V173z M818.7,264c0-61.4,40.1-96.5,89.1-96.5s89.1,35.2,89.1,97.7v12h-132c1.2,28.1,21,45.6,46.3,45.6 c14.8,0,29.9-6.2,37.3-21l44.7,8c-13.6,34.8-47.5,53.6-83.6,53.6c-49.3,0-91-35.1-91-96.5V264z M637.4,99h47.5v92.2 c10.2-11.7,26.8-21.9,50.3-21.9c40.1,0,78.6,29.6,78.6,89.4v13.6c0,59.8-38.2,89.4-79.9,89.4c-25,0-42.5-10.2-52.4-22.2V358h-44.1 V99z M544.3,100.8h48.1v48.1h-48.1V100.8z M472.1,100.8h48.1v48.1h-48.1V100.8z M450.5,173H498v109.2c0,24.7,11.4,38.9,30.8,38.9 c21,0,33.9-17.3,33.9-41.9V173h47.5v185h-44.1v-20.4c-12.3,17.6-31.8,24.1-50.3,24.1c-40.1,0-65.4-27.1-65.4-68.1V173z  M300.7,268.6V358h-50.9V99h50.9v107.9c5.5-10.8,12.3-21.3,18.5-30.2l53-77.7h57.7l-74.9,107l99,152h-61.1l-73.4-114.4 L300.7,268.6z M440,628l-48.1-77.1l-16.3,17.9V628h-45.9V369h47.5v142.8l60.1-68.8h57.7l-69.7,76.5L495.9,628H440z M653.4,628 h-44.1v-20.3c-11.4,11.7-29.6,24-57.7,24c-38.2,0-61.7-23.1-61.7-54v-2.5c0-30.2,21.3-58.9,71.5-58.9h45.9v-5.5 c0-22.2-12-34.2-32.7-34.2c-17.3,0-29.6,8-35.5,23.7l-43.8-8c14.8-39.8,47.8-53,81.7-53c48.4,0,76.2,26.8,76.2,69.7V628z  M785.4,628H749c-34.8,0-56.7-18.5-56.7-55.2v-89.1H667V443h26.8v-55.5h44.1V443h47.5v40.7h-45.6v80.5c0,16.3,8.3,23.1,21.9,23.1 h23.7V628z M868,631.7c-33,0-65.7-12.3-84.8-49l40.7-16c8.6,18.2,21.3,27.8,41.9,27.8c19.1,0,29.6-8.3,29.6-20.7 c0-12.3-10.2-17-23.4-19.4l-27.8-4.9c-41-7.7-57.3-26.2-57.3-50.9c0-30.5,23.7-59.2,73.4-59.2c32.4,0,61.1,12.3,79.2,42.5 l-40.4,16.3c-8.3-15.1-21-21.6-36.7-21.6c-18.2,0-28.1,8.3-28.1,19.4c0,9.6,8,14.8,22.2,17.6l27.4,4.9c41,8,58.9,25.3,58.9,52.4 C942.9,603.3,918,631.7,868,631.7z M1121.4,547.2h-132c1.2,28.1,21,45.6,46.3,45.6c14.8,0,29.9-6.2,37.3-21l44.7,8 c-13.6,34.8-47.5,53.7-83.6,53.7c-49.3,0-91-35.2-91-96.5V534c0-61.4,40.1-96.5,89.1-96.5s89.1,35.2,89.1,97.7V547.2z  M1209.3,285.8h-90.7v-40.7h90.7V285.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1032.3,474.8c-20.3,0-38.5,14.2-41,41.6h82.6C1071.2,488.9,1052.7,474.8,1032.3,474.8z"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTitleLatKiberkvests, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/title_lat_kiberkvests.4c7c37ac.svg";
export { ForwardRef as ReactComponent };